export default [
    ['PC', 'PC端'],
    ['MOBILE', '手机端'],
]
